import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet"
import TrackList from "./TrackList";

interface Props {
    personData: any;
    myRegion: string;
    searchRegion: string;
}

const ComposerDetail = ({personData, myRegion, searchRegion}: Props) => {
    const [currentUrl, setCurrentUrl] = useState<string>('');

    useEffect(() => {
        setCurrentUrl(window.location.href)
    }, []);
    return (
        <div>
            <Helmet>
                <title>{`Rocksmith+ Composer Detail: `+personData.first_name+` `+personData.last_name}</title>
                <meta name="keywords" content={"composer, "+personData.first_name+` `+personData.last_name} />
                <meta name="description" content={"Rocksmith+ songs by "+personData.first_name+` `+personData.last_name} />
                <meta property="og:title" content={"Rocksmith+ Composer Detail: "+personData.first_name+` `+personData.last_name}/>
                <meta property="og:image" content={"/rs+/img/VPNSmith.png"}/>
                <meta property="og:url" content={currentUrl}/>
                <meta property="og:description" content={"Rocksmith+ songs by "+personData.first_name+` `+personData.last_name}/>
                <meta name="twitter:title" content={"Rocksmith+ songs by "+personData.first_name+` `+personData.last_name} />
                <meta name="twitter:description" content={"Rocksmith+ songs by "+personData.first_name+` `+personData.last_name}/>
                <meta name="twitter:image" content="/rs+/img/VPNSmith.png" />
            </Helmet>
            <table id="PersonDetails" border={0}>
                <thead>
                    <tr><th colSpan={3}>Credited person</th></tr>
                </thead>
                <tbody>
                    <tr><th>Name:</th><td title={personData.ID ? personData.ID : null}>{personData ? personData.first_name : null} {personData ? personData.last_name : null}</td></tr>
                    { personData.credits ? Object.keys(personData.credits).map((i,j) => (
                        <tr key={i}><td>{i}</td><td><TrackList trackData={personData.credits[i]} myRegion={myRegion} searchRegion={searchRegion} displayPage={"composer"}/></td></tr>
                    ))
                    : null }
                </tbody>
            </table>
        </div>
    )
}

export default ComposerDetail